"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, i, s, n, o, r) {
  try {
    var a = e[o](r),
      _ = a.value;
  } catch (e) {
    return void i(e);
  }
  a.done ? t(_) : Promise.resolve(_).then(s, n);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      i = arguments;
    return new Promise(function (s, n) {
      var o = e.apply(t, i);
      function r(e) {
        asyncGeneratorStep(o, s, n, r, a, "next", e);
      }
      function a(e) {
        asyncGeneratorStep(o, s, n, r, a, "throw", e);
      }
      r(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var i = 0; i < t.length; i++) {
    var s = t[i];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function _createClass(e, t, i) {
  return t && _defineProperties(e.prototype, t), i && _defineProperties(e, i), e;
}
var flatten = require("flat"),
  unflatten = require("flat").unflatten,
  mapper = require("./mapper"),
  CriticalInput = require("./../CriticalInput.service");
mapper = new mapper.Mapper();
var backendService = require("./../Backend.service"),
  utilityModule = require("./../Utility.module"),
  SbliHelper = function () {
    return _createClass(function e(t) {
      _classCallCheck(this, e), this.clientId = t, this.state = "CA", this.dataCategory = {
        initSESSION: "SBLI_initSESSION",
        getQUOTE: "SBLI_getQUOTE",
        initAPP: "SBLI_initAPP",
        updatePII: "SBLI_updatePII",
        getAPPQ: "SBLI_getAPPQ",
        submitAPPQA: "SBLI_submitAPPQA",
        submitAUTH: "SBLI_submitAUTH",
        getDECISION: "SBLI_getDECISION",
        getFORMS: "SBLI_getFORMS",
        submitBENE: "SBLI_submitBENE",
        getPREMIUM: "SBLI_getPREMIUM",
        offerACCEPTANCE: "SBLI_offerACCEPTANCE",
        appSIGN: "SBLI_appSIGN",
        submitPAYINFO: "SBLI_submitPAYINFO",
        getPOLICYNUMBER: "SBLI_getPOLICYNUMBER",
        updateSESSION: "SBLI_updateSESSION"
      }, this.questionIdKeyBinding = {
        sbli_surgeryInfo_Option1: "1250",
        sbli_surgeryInfo_Option2: "1250",
        sbli_surgeryInfo_Option3: "1250",
        sbli_surgeryInfo_Option4: "1250",
        sbli_surgeryInfo_Option5: "1250",
        sbli_surgeryInfo_Option6: "1250",
        sbli_surgeryInfo_Option7: "1250",
        sbli_surgeryInfo_Option8: "1250",
        sbli_surgeryInfo_Option9: "1250",
        sbli_surgeryInfo_Option10: "1250",
        sbli_surgeryInfo_Option11: "1250",
        sbli_anyTestInfo_Option1: "1250",
        sbli_anyTestInfo_Option2: "1250",
        sbli_anyTestInfo_Option3: "1250",
        sbli_anyTestInfo_Option4: "1250",
        sbli_anyTestInfo_Option5: "1250",
        sbli_anyTestInfo_Option6: "1250",
        sbli_anyTestInfo_Option7: "1250",
        sbli_anyTestInfo_Option8: "1250",
        sbli_anyTestInfo_Option9: "1250",
        sbli_anyTestInfo_Option10: "1250",
        sbli_anyTestInfo_Option11: "1250",
        sbli_anyTestInfo_Option12: "1250",
        sbli_Surgery_noneOfTheAbove: "1250",
        sbli_us: "1260",
        sbli_hasPending: "1010",
        sbli_annuity: "1011",
        sbli_military: "1120",
        sbli_annualIncome: "1030",
        sbli_employee: "1020",
        sbli_employee_retired: "1130",
        sbli_employee_nonworkinspouce: "1130",
        sbli_employee_fulltimestudent: "1130",
        sbli_employee_notworking: "1130",
        sbli_Student_Type_bachelordegree: "1135",
        sbli_Student_Type_masterdegree: "1135",
        sbli_Student_Type_doctorate: "1135",
        sbli_Student_Type_other: "1135",
        sbli_height: "1002",
        sbli_weight: "1003",
        tobacco_usage_one: "1080",
        tobacco_usage_two: "1080",
        tobacco_usage_three: "1080",
        tobacco_usage_four: "1080",
        tobacco_usage_five: "1080",
        sbli_disablility_benefits: "1040",
        sbli_parentsibling_disease: "CA" == this.state ? "1141" : "1140",
        sbli_disease_sibling_died: "1150",
        sbli_disease_two_or_more_sibling_died: "1160",
        sbli_two_year_plan: "1180",
        sbli_two_year_plan_pilot: "1190",
        sbli_two_year_plan_underwater: "1210",
        sbli_diagnosed_or_tratment_cancer: "1220",
        sbli_carcinoma_skin: "1230",
        sbli_diagnosed_or_tratment_drug_abuse: "1240",
        sbli_guilty_felony: "1270",
        sbli_diagnosed_or_treatment_Covid: "1930",
        sbli_covid_positive_last_30days: "1940",
        sbli_Covid_treatment: "1950",
        sbli_convicted_reckless_driving: "1061",
        sbli_moving_violations_convicted: "1175",
        sbli_moving_violations_convicted_count_one: "CA" == this.state ? "1171" : "1170",
        sbli_moving_violations_convicted_count_two: "CA" == this.state ? "1171" : "1170",
        sbli_moving_violations_convicted_count_three: "CA" == this.state ? "1171" : "1170",
        sbli_moving_violations_convicted_count_four: "CA" == this.state ? "1171" : "1170",
        sbli_moving_violations_convicted_count_five: "CA" == this.state ? "1171" : "1170",
        sbli_moving_violations_convicted_count_six: "CA" == this.state ? "1171" : "1170",
        sbli_hospitalized_other_reason: "1680",
        sbli_depression: "1100",
        sbli_diabetes_treated: "1100",
        sbli_oral_medication: "1100",
        sbli_Hemoglobin_below7: "1100",
        sbli_Emphysema: "1100",
        sbli_Peripheral: "1100",
        sbli_HIV: "1100",
        sbli_Kidneydisease: "1100",
        sbli_Livercirrhosis: "1100",
        sbli_ALS: "1100",
        sbli_Stroke: "1100",
        sbli_Rheumatoidarthritis: "1100",
        sbli_SleepApnea: "1100",
        sbli_Asthma: "1100",
        sbli_Heartdisease: "1100",
        sbli_Noneoftheabove: "1100",
        sbli_active_duty: "1960",
        sbli_reserve_national_guard: "1960",
        sbli_troubled_areas: "1970",
        sbli_hazardous_activity: "1970",
        sbli_neither_of_these: "1970",
        sbli_householdIncome: "1130",
        sbli_actively_seeking_work: "1130",
        sbli_last_active_working_month: "1990",
        sbli_within_last_year: "2020",
        sbli_one_to_two_years_ago: "2020",
        sbli_two_to_three_years_ago: "2020",
        sbli_three_to_four_years_ago: "2020",
        sbli_four_to_five_years_ago: "2020",
        sbli_disablitymonth: "2025",
        sbli_chronic_illness: "2010",
        sbli_hospitalized_reason: "2015",
        sbli_psychiatric_treatment: "1100",
        sbli_ongoing_treatment: "1100",
        sbli_loss_of_work: "1100",
        sbli_none_of_above: "1100"
      }, this.answerOptionIdKeyBinding = {
        sbli_surgeryInfo_Option1: "1250111",
        sbli_surgeryInfo_Option2: "1250112",
        sbli_surgeryInfo_Option3: "1250113",
        sbli_surgeryInfo_Option4: "1250114",
        sbli_surgeryInfo_Option5: "1250115",
        sbli_surgeryInfo_Option6: "1250116",
        sbli_surgeryInfo_Option7: "1250117",
        sbli_surgeryInfo_Option8: "1250118",
        sbli_surgeryInfo_Option9: "1250119",
        sbli_surgeryInfo_Option10: "12501110",
        sbli_surgeryInfo_Option11: "12501111",
        sbli_anyTestInfo_Option1: "1250211",
        sbli_anyTestInfo_Option2: "1250212",
        sbli_anyTestInfo_Option3: "1250213",
        sbli_anyTestInfo_Option4: "1250214",
        sbli_anyTestInfo_Option5: "1250215",
        sbli_anyTestInfo_Option6: "1250216",
        sbli_anyTestInfo_Option7: "1250217",
        sbli_anyTestInfo_Option8: "1250218",
        sbli_anyTestInfo_Option9: "1250219",
        sbli_anyTestInfo_Option10: "12502110",
        sbli_anyTestInfo_Option11: "12502111",
        sbli_anyTestInfo_Option12: "12502112",
        sbli_Surgery_noneOfTheAbove: "12503",
        sbli_employee_retired: "11301",
        sbli_employee_nonworkinspouce: "11302",
        sbli_employee_fulltimestudent: "11303",
        sbli_employee_notworking: "11304",
        sbli_Student_Type_bachelordegree: "11351",
        sbli_Student_Type_masterdegree: "11352",
        sbli_Student_Type_doctorate: "11353",
        sbli_Student_Type_other: "11354",
        tobacco_usage_one: "10801",
        tobacco_usage_two: "10802",
        tobacco_usage_three: "10803",
        tobacco_usage_four: "10804",
        tobacco_usage_five: "10805",
        sbli_moving_violations_convicted_count_one: "11701",
        sbli_moving_violations_convicted_count_two: "11702",
        sbli_moving_violations_convicted_count_three: "11703",
        sbli_moving_violations_convicted_count_four: "11704",
        sbli_moving_violations_convicted_count_five: "11705",
        sbli_moving_violations_convicted_count_six: "11706",
        sbli_depression: "110053",
        sbli_diabetes_treated: "110041",
        sbli_oral_medication: "1100412",
        sbli_Hemoglobin_below7: "1100413",
        sbli_Emphysema: "110011",
        sbli_Peripheral: "110019",
        sbli_HIV: "11007",
        sbli_Kidneydisease: "11008",
        sbli_Livercirrhosis: "11009",
        sbli_ALS: "110015",
        sbli_Stroke: "110018",
        sbli_Rheumatoidarthritis: "1100121",
        sbli_SleepApnea: "1100131",
        sbli_Asthma: "110021",
        sbli_Heartdisease: "11006",
        sbli_Noneoftheabove: "110014",
        sbli_active_duty: "19601",
        sbli_reserve_national_guard: "19602",
        sbli_troubled_areas: "19701",
        sbli_hazardous_activity: "19702",
        sbli_neither_of_these: "19703",
        sbli_householdIncome: "1980",
        sbli_actively_seeking_work: "1990",
        sbli_last_active_working_month: "2000",
        sbli_within_last_year: "20201",
        sbli_one_to_two_years_ago: "20202",
        sbli_two_to_three_years_ago: "20203",
        sbli_three_to_four_years_ago: "20204",
        sbli_four_to_five_years_ago: "20205",
        sbli_disablitymonth: "2025",
        sbli_psychiatric_treatment: "1100531",
        sbli_ongoing_treatment: "1100532",
        sbli_loss_of_work: "1100533",
        sbli_none_of_above: "1100534"
      }, this.arcId = "ARC7274772595";
    }, [{
      key: "initSESSION",
      value: (g = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, i, s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = {
                productId: "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? 81410 : 8141,
                distributorId: 8444
              }, e.next = 3, utilityModule.getClientIdTimestamp(this.clientId);
            case 3:
              return i = e.sent, e.next = 6, backendService.getQuotesFromSBLIAfficiency(t, i, this.dataCategory.initSESSION, this.clientId, "SBLI");
            case 6:
              return s = e.sent, n = JSON.parse(s.Payload), o = n.body.output[0]["output.arcId"], console.log("SBLI arcId initSESSION : ", o), r = {
                id: this.clientId,
                clientId: this.clientId,
                uid: this.clientId,
                arcId: o
              }, e.next = 13, backendService.saveUpdateClientData(this.clientId, r);
            case 13:
              if (!((n = n.body.output).length > 0)) {
                e.next = 24;
                break;
              }
              if (200 == n[0]["output.statusCode"]) {
                e.next = 20;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: n[0],
                statusCode: n[0]["output.statusCode"],
                msgCode: n[0]["output.msgCode"],
                msgText: n[0]["output.msgText"] ? n[0]["output.msgText"] : n[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 20:
              return _ = {
                sbliError: !1,
                sbliOutput: n[0],
                statusCode: n[0]["output.statusCode"],
                msgCode: n[0]["output.msgCode"],
                msgText: n[0]["output.msgText"] ? n[0]["output.msgText"] : n[0]["output.msgTxt"]
              }, e.abrupt("return", _);
            case 22:
              e.next = 25;
              break;
            case 24:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 25:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return g.apply(this, arguments);
      })
    }, {
      key: "getQuote",
      value: (h = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var i,
          s,
          n,
          o,
          r,
          a,
          _,
          u,
          l,
          p = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return i = p.length > 1 && void 0 !== p[1] ? p[1] : "", (s = t).term = +s.term >= 20 ? "20" : s.term, s.term = +s.term >= 15 && s.term < 20 ? "15" : s.term, s.term = +s.term >= 10 && s.term < 15 ? "10" : s.term, s.height = s.height.replace("ft ", ".").replace("inch", "").split("."), 1 == s.height[1].length && (s.height[1] = "0" + s.height[1]), s.height = s.height.join("."), (n = mapper.mapdata(this.id, "SBLI", s)).quoteRateClassRequest = 0, "" != i && (n.arcId = i), console.log("SBLI arcId getQUOTE IP : ", n.arcId), e.next = 14, utilityModule.getClientIdTimestamp(this.clientId);
            case 14:
              return o = e.sent, e.next = 17, backendService.getQuotesFromSBLIAfficiency(n, o, this.dataCategory.getQUOTE, this.clientId, "SBLI");
            case 17:
              if (r = e.sent, console.log("SBLI OP : ", r), !r.Payload) {
                e.next = 28;
                break;
              }
              return a = r, a = JSON.parse(a.Payload), _ = a.body.output[0]["output.arcId"], console.log("SBLI arcId getQUOTE OP : ", _), u = {
                id: this.clientId,
                clientId: this.clientId,
                uid: this.clientId,
                arcId: _
              }, e.next = 28, backendService.saveUpdateClientData(this.clientId, u);
            case 28:
              return l = this.getSBLIAmount(r), e.abrupt("return", l);
            case 30:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return h.apply(this, arguments);
      })
    }, {
      key: "initApp",
      value: (c = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t.term = +t.term > 20 ? "20" : t.term, t.term = +t.term > 15 && t.term < 20 ? "15" : t.term, t.term = +t.term > 10 && t.term < 15 ? "10" : t.term, (s = this.getAge(t.dob)) > 18 && s < 50 ? +t.coverage > 1e6 && (t.coverage = "1000000") : +t.coverage > 5e5 && (t.coverage = "500000"), (n = mapper.mapdata(this.id, "SBLI", t)).arcId = i.arcId, n.callReferenceCode = "APP", o = (o = i.SBLI.sbli_ssn).replace(/-/g, ""), n.ssn = o, n.usCitizenFlag = "1", n.state = t.state, n.email = t.email, r = (r = t.phone).replace(/-/g, ""), n.phone = r, n.firstName = t.firstName, n.middleName = "", n.lastName = t.lastName, n.country = "US", n.city = t.city, n.addressLine1 = t.address, n.addressLine2 = "", console.log("initApp sbliInputJson : ", n), e.next = 27, utilityModule.getClientIdTimestamp(this.clientId);
            case 27:
              return a = e.sent, e.next = 30, backendService.getQuotesFromSBLIAfficiency(n, a, this.dataCategory.initAPP, this.clientId, "SBLI");
            case 30:
              return _ = e.sent, e.abrupt("return", this.getProcessedOutput(_));
            case 32:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return c.apply(this, arguments);
      })
    }, {
      key: "updatePII",
      value: (b = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return s = (s = i.SBLI.sbli_ssn).replace(/-/g, ""), t.phone.includes("-") && (t.phone = t.phone.replace(/-/g, "")), n = {
                arcId: i.arcId,
                firstName: t.firstName,
                lastName: t.lastName,
                dob: t.dob,
                gender: t.gender,
                addressLine1: t.address,
                addressLine2: "",
                city: t.city,
                state: t.state,
                country: "US",
                healthStatusRank: 4,
                zip: t.zip,
                ssn: s,
                email: t.email,
                phone: t.phone,
                usCitizenFlag: 0
              }, console.log("initApp sbliInputJson : ", n), e.next = 7, utilityModule.getClientIdTimestamp(this.clientId);
            case 7:
              return o = e.sent, e.next = 10, backendService.getQuotesFromSBLIAfficiency(n, o, this.dataCategory.updatePII, this.clientId, "SBLI");
            case 10:
              return r = e.sent, e.abrupt("return", this.getProcessedOutput(r));
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return b.apply(this, arguments);
      })
    }, {
      key: "getAPPQ",
      value: (d = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return (s = {
                callReferenceCode: "UWQ"
              }).arcId = i.arcId, s.state = t.state, console.log("getAPPQ sbliInputJson : ", s), e.next = 6, utilityModule.getClientIdTimestamp(this.clientId);
            case 6:
              return n = e.sent, e.next = 9, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.getAPPQ, this.clientId, "SBLI");
            case 9:
              if (o = e.sent, !((r = (r = JSON.parse(o.Payload)).body.output).length > 0)) {
                e.next = 22;
                break;
              }
              if (200 == r[0]["output.statusCode"]) {
                e.next = 18;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: r[0],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 18:
              return _ = {
                sbliError: !1,
                sbliOutput: r[0],
                appQJson: r[0]["output.appQJson"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", _);
            case 20:
              e.next = 23;
              break;
            case 22:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 23:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return d.apply(this, arguments);
      })
    }, {
      key: "submitAPPQAOld",
      value: (p = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i, s) {
        var n, o, r, a, _, u, l, p, d, b, c, h, g, y, m, I, O, f, w, S, v, B, T, A, K, P, C, N, x, k, Q, J, q, L, E, R, F, M, Y, H, U, G, z, D, V, W, j, Z, $, X, ee, te, ie, se, ne, oe, re, ae, _e, ue, le, pe, de, be, ce, he, ge, ye, me, Ie, Oe, fe, we, Se, ve, Be, Te, Ae, Ke, Pe, Ce, Ne, xe, ke, Qe, Je, qe, Le, Ee, Re, Fe, Me, Ye, He, Ue, Ge, ze, De, Ve, We, je, Ze, $e, Xe, et, tt, it, st, nt;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              if (this.state = s.state, (n = {
                appQA: []
              }).arcId = t, i.hasOwnProperty("sbli_surgeryInfo_Option1") && (o = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option1, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option1, i.sbli_surgeryInfo_Option1), n.appQA.push(o)), i.hasOwnProperty("sbli_surgeryInfo_Option2") && (r = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option2, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option2, i.sbli_surgeryInfo_Option2), n.appQA.push(r)), i.hasOwnProperty("sbli_surgeryInfo_Option3") && (a = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option3, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option3, i.sbli_surgeryInfo_Option3), n.appQA.push(a)), i.hasOwnProperty("sbli_surgeryInfo_Option4") && (_ = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option4, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option4, i.sbli_surgeryInfo_Option4), n.appQA.push(_)), i.hasOwnProperty("sbli_surgeryInfo_Option5") && (u = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option5, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option5, i.sbli_surgeryInfo_Option5), n.appQA.push(u)), i.hasOwnProperty("sbli_surgeryInfo_Option6") && (l = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option6, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option6, i.sbli_surgeryInfo_Option6), n.appQA.push(l)), i.hasOwnProperty("sbli_surgeryInfo_Option7") && (p = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option7, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option7, i.sbli_surgeryInfo_Option7), n.appQA.push(p)), i.hasOwnProperty("sbli_surgeryInfo_Option8") && (d = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option8, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option8, i.sbli_surgeryInfo_Option8), n.appQA.push(d)), i.hasOwnProperty("sbli_surgeryInfo_Option9") && (b = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option9, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option9, i.sbli_surgeryInfo_Option9), n.appQA.push(b)), i.hasOwnProperty("sbli_surgeryInfo_Option10") && (c = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option10, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option10, i.sbli_surgeryInfo_Option10), n.appQA.push(c)), i.hasOwnProperty("sbli_surgeryInfo_Option11")) for (h = i.sbli_surgeryInfo_Option11, g = 0; g < h.length; g++) y = this.createJSON(this.questionIdKeyBinding.sbli_surgeryInfo_Option11, this.answerOptionIdKeyBinding.sbli_surgeryInfo_Option11, h[g]), n.appQA.push(y);
              if (i.hasOwnProperty("sbli_anyTestInfo_Option1") && (m = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option1, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option1, i.sbli_anyTestInfo_Option1), n.appQA.push(m)), i.hasOwnProperty("sbli_anyTestInfo_Option2") && (I = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option1, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option2, i.sbli_anyTestInfo_Option2), n.appQA.push(I)), i.hasOwnProperty("sbli_anyTestInfo_Option3") && (O = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option3, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option3, i.sbli_anyTestInfo_Option3), n.appQA.push(O)), i.hasOwnProperty("sbli_anyTestInfo_Option4") && (f = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option4, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option4, i.sbli_anyTestInfo_Option4), n.appQA.push(f)), i.hasOwnProperty("sbli_anyTestInfo_Option5") && (w = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option5, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option5, i.sbli_anyTestInfo_Option5), n.appQA.push(w)), i.hasOwnProperty("sbli_anyTestInfo_Option6") && (S = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option6, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option6, i.sbli_anyTestInfo_Option6), n.appQA.push(S)), i.hasOwnProperty("sbli_anyTestInfo_Option7") && (v = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option7, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option7, i.sbli_anyTestInfo_Option7), n.appQA.push(v)), i.hasOwnProperty("sbli_anyTestInfo_Option8") && (B = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option8, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option8, i.sbli_anyTestInfo_Option8), n.appQA.push(B)), i.hasOwnProperty("sbli_anyTestInfo_Option9") && (T = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option9, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option9, i.sbli_anyTestInfo_Option9), n.appQA.push(T)), i.hasOwnProperty("sbli_anyTestInfo_Option10") && (A = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option10, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option10, i.sbli_anyTestInfo_Option10), n.appQA.push(A)), i.hasOwnProperty("sbli_anyTestInfo_Option11") && (K = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option11, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option11, i.sbli_anyTestInfo_Option11), n.appQA.push(K)), i.hasOwnProperty("sbli_anyTestInfo_Option12")) for (P = i.sbli_anyTestInfo_Option12, C = 0; C < P.length; C++) N = this.createJSON(this.questionIdKeyBinding.sbli_anyTestInfo_Option12, this.answerOptionIdKeyBinding.sbli_anyTestInfo_Option12, P[C]), n.appQA.push(N);
              if (i.hasOwnProperty("sbli_Surgery_noneOfTheAbove") && (x = this.createJSON(this.questionIdKeyBinding.sbli_Surgery_noneOfTheAbove, this.answerOptionIdKeyBinding.sbli_Surgery_noneOfTheAbove, i.sbli_Surgery_noneOfTheAbove), n.appQA.push(x)), i.hasOwnProperty("sbli_us") && (k = this.createJSON(this.questionIdKeyBinding.sbli_us, this.answerOptionIdKeyBinding.sbli_us, i.sbli_us), n.appQA.push(k)), i.hasOwnProperty("sbli_hasPending") && (Q = this.createJSON(this.questionIdKeyBinding.sbli_hasPending, this.answerOptionIdKeyBinding.sbli_hasPending, i.sbli_hasPending), n.appQA.push(Q)), i.hasOwnProperty("sbli_annuity") && (J = this.createJSON(this.questionIdKeyBinding.sbli_annuity, this.answerOptionIdKeyBinding.sbli_annuity, i.sbli_annuity), n.appQA.push(J)), i.hasOwnProperty("sbli_military") && (q = this.createJSON(this.questionIdKeyBinding.sbli_military, this.answerOptionIdKeyBinding.sbli_military, i.sbli_military), n.appQA.push(q)), i.hasOwnProperty("sbli_annualIncome") && (L = i.sbli_annualIncome.replace(/,/g, ""), E = this.createJSON(this.questionIdKeyBinding.sbli_annualIncome, this.answerOptionIdKeyBinding.sbli_annualIncome, L), n.appQA.push(E)), i.hasOwnProperty("sbli_employee") && (R = this.createJSON(this.questionIdKeyBinding.sbli_employee, this.answerOptionIdKeyBinding.sbli_employee, i.sbli_employee), n.appQA.push(R)), i.hasOwnProperty("sbli_employee_retired") && "Yes" == i.sbli_employee_retired && (F = this.createJSON(this.questionIdKeyBinding.sbli_employee_retired, this.answerOptionIdKeyBinding.sbli_employee_retired, i.sbli_employee_retired), n.appQA.push(F)), i.hasOwnProperty("sbli_employee_nonworkinspouce") && "Yes" == i.sbli_employee_nonworkinspouce && (M = this.createJSON(this.questionIdKeyBinding.sbli_employee_nonworkinspouce, this.answerOptionIdKeyBinding.sbli_employee_nonworkinspouce, i.sbli_employee_nonworkinspouce), n.appQA.push(M)), i.hasOwnProperty("sbli_employee_fulltimestudent") && "Yes" == i.sbli_employee_fulltimestudent && (Y = this.createJSON(this.questionIdKeyBinding.sbli_employee_fulltimestudent, this.answerOptionIdKeyBinding.sbli_employee_fulltimestudent, i.sbli_employee_fulltimestudent), n.appQA.push(Y)), i.hasOwnProperty("sbli_employee_notworking") && "Yes" == i.sbli_employee_notworking && (H = this.createJSON(this.questionIdKeyBinding.sbli_employee_notworking, this.answerOptionIdKeyBinding.sbli_employee_notworking, i.sbli_employee_notworking), n.appQA.push(H)), i.hasOwnProperty("sbli_Student_Type_bachelordegree") && "Yes" == i.sbli_Student_Type_bachelordegree && (U = this.createJSON(this.questionIdKeyBinding.sbli_Student_Type_bachelordegree, this.answerOptionIdKeyBinding.sbli_Student_Type_bachelordegree, i.sbli_Student_Type_bachelordegree), n.appQA.push(U)), i.hasOwnProperty("sbli_Student_Type_masterdegree") && "Yes" == i.sbli_Student_Type_masterdegree && (G = this.createJSON(this.questionIdKeyBinding.sbli_Student_Type_masterdegree, this.answerOptionIdKeyBinding.sbli_Student_Type_masterdegree, i.sbli_Student_Type_masterdegree), n.appQA.push(G)), i.hasOwnProperty("sbli_Student_Type_doctorate") && "Yes" == i.sbli_Student_Type_doctorate && (z = this.createJSON(this.questionIdKeyBinding.sbli_Student_Type_doctorate, this.answerOptionIdKeyBinding.sbli_Student_Type_doctorate, i.sbli_Student_Type_doctorate), n.appQA.push(z)), i.hasOwnProperty("sbli_Student_Type_other") && "Yes" == i.sbli_Student_Type_other && (D = this.createJSON(this.questionIdKeyBinding.sbli_Student_Type_other, this.answerOptionIdKeyBinding.sbli_Student_Type_other, i.sbli_Student_Type_other), n.appQA.push(D)), i.hasOwnProperty("sbli_householdIncome") && (V = this.createJSON(this.questionIdKeyBinding.sbli_householdIncome, this.answerOptionIdKeyBinding.sbli_householdIncome, i.sbli_householdIncome), n.appQA.push(V)), i.hasOwnProperty("sbli_actively_seeking_work") && (W = this.createJSON(this.questionIdKeyBinding.sbli_actively_seeking_work, this.answerOptionIdKeyBinding.sbli_actively_seeking_work, i.sbli_actively_seeking_work), n.appQA.push(W)), i.hasOwnProperty("sbli_last_active_working_month") && (j = this.createJSON(this.questionIdKeyBinding.sbli_last_active_working_month, this.answerOptionIdKeyBinding.sbli_last_active_working_month, i.sbli_last_active_working_month), n.appQA.push(j)), i.hasOwnProperty("sbli_within_last_year") && "Yes" == i.sbli_disablility_benefits && (Z = this.createJSON(this.questionIdKeyBinding.sbli_within_last_year, this.answerOptionIdKeyBinding.sbli_within_last_year, i.sbli_within_last_year), n.appQA.push(Z)), i.hasOwnProperty("sbli_one_to_two_years_ago") && "Yes" == i.sbli_disablility_benefits && ($ = this.createJSON(this.questionIdKeyBinding.sbli_one_to_two_years_ago, this.answerOptionIdKeyBinding.sbli_one_to_two_years_ago, i.sbli_one_to_two_years_ago), n.appQA.push($)), i.hasOwnProperty("sbli_two_to_three_years_ago") && "Yes" == i.sbli_disablility_benefits && (X = this.createJSON(this.questionIdKeyBinding.sbli_two_to_three_years_ago, this.answerOptionIdKeyBinding.sbli_two_to_three_years_ago, i.sbli_two_to_three_years_ago), n.appQA.push(X)), i.hasOwnProperty("sbli_three_to_four_years_ago") && "Yes" == i.sbli_disablility_benefits && (ee = this.createJSON(this.questionIdKeyBinding.sbli_three_to_four_years_ago, this.answerOptionIdKeyBinding.sbli_three_to_four_years_ago, i.sbli_three_to_four_years_ago), n.appQA.push(ee)), i.hasOwnProperty("sbli_four_to_five_years_ago") && "Yes" == i.sbli_disablility_benefits && (te = this.createJSON(this.questionIdKeyBinding.sbli_four_to_five_years_ago, this.answerOptionIdKeyBinding.sbli_four_to_five_years_ago, i.sbli_four_to_five_years_ago), n.appQA.push(te)), i.hasOwnProperty("sbli_disablitymonth") && "Yes" == i.sbli_disablility_benefits && (ie = this.createJSON(this.questionIdKeyBinding.sbli_disablitymonth, this.answerOptionIdKeyBinding.sbli_disablitymonth, i.sbli_disablitymonth), n.appQA.push(ie)), i.hasOwnProperty("sbli_chronic_illness") && "Yes" == i.sbli_hospitalized_other_reason && (se = this.createJSON(this.questionIdKeyBinding.sbli_chronic_illness, this.answerOptionIdKeyBinding.sbli_chronic_illness, i.sbli_chronic_illness), n.appQA.push(se)), i.hasOwnProperty("sbli_hospitalized_reason") && "Yes" == i.sbli_chronic_illness && (ne = this.createJSON(this.questionIdKeyBinding.sbli_hospitalized_reason, this.answerOptionIdKeyBinding.sbli_hospitalized_reason, i.sbli_hospitalized_reason), n.appQA.push(ne)), i.hasOwnProperty("sbli_psychiatric_treatment") && (oe = this.createJSON(this.questionIdKeyBinding.sbli_psychiatric_treatment, this.answerOptionIdKeyBinding.sbli_psychiatric_treatment, i.sbli_psychiatric_treatment), n.appQA.push(oe)), i.hasOwnProperty("sbli_ongoing_treatment") && (re = this.createJSON(this.questionIdKeyBinding.sbli_ongoing_treatment, this.answerOptionIdKeyBinding.sbli_ongoing_treatment, i.sbli_ongoing_treatment), n.appQA.push(re)), i.hasOwnProperty("sbli_loss_of_work") && (ae = this.createJSON(this.questionIdKeyBinding.sbli_loss_of_work, this.answerOptionIdKeyBinding.sbli_loss_of_work, i.sbli_loss_of_work), n.appQA.push(ae)), i.hasOwnProperty("sbli_none_of_above") && (_e = this.createJSON(this.questionIdKeyBinding.sbli_none_of_above, this.answerOptionIdKeyBinding.sbli_none_of_above, i.sbli_none_of_above), n.appQA.push(_e)), i.hasOwnProperty("sbli_height") && (ue = (ue = (ue = (ue = i.sbli_height).replace(/ /g, "")).replace("ft", ".")).replace("in", ""), le = this.createJSON(this.questionIdKeyBinding.sbli_height, this.answerOptionIdKeyBinding.sbli_height, ue), n.appQA.push(le)), i.hasOwnProperty("sbli_weight") && (pe = (pe = (pe = i.sbli_weight).replace(/ /g, "")).replace("lbs", ""), de = this.createJSON(this.questionIdKeyBinding.sbli_weight, this.answerOptionIdKeyBinding.sbli_weight, pe), n.appQA.push(de)), i.hasOwnProperty("tobacco_usage_one") && "Yes" == i.tobacco_usage_one && (be = this.createJSON(this.questionIdKeyBinding.tobacco_usage_one, this.answerOptionIdKeyBinding.tobacco_usage_one, i.tobacco_usage_one), n.appQA.push(be)), i.hasOwnProperty("tobacco_usage_two") && "Yes" == i.tobacco_usage_two && (ce = this.createJSON(this.questionIdKeyBinding.tobacco_usage_two, this.answerOptionIdKeyBinding.tobacco_usage_two, i.tobacco_usage_two), n.appQA.push(ce)), i.hasOwnProperty("tobacco_usage_three") && "Yes" == i.tobacco_usage_three && (he = this.createJSON(this.questionIdKeyBinding.tobacco_usage_three, this.answerOptionIdKeyBinding.tobacco_usage_three, i.tobacco_usage_three), n.appQA.push(he)), i.hasOwnProperty("tobacco_usage_four") && "Yes" == i.tobacco_usage_four && (ge = this.createJSON(this.questionIdKeyBinding.tobacco_usage_four, this.answerOptionIdKeyBinding.tobacco_usage_four, i.tobacco_usage_four), n.appQA.push(ge)), i.hasOwnProperty("tobacco_usage_five") && "Yes" == i.tobacco_usage_five && (ye = this.createJSON(this.questionIdKeyBinding.tobacco_usage_five, this.answerOptionIdKeyBinding.tobacco_usage_five, i.tobacco_usage_five), n.appQA.push(ye)), i.hasOwnProperty("sbli_disablility_benefits") && (me = this.createJSON(this.questionIdKeyBinding.sbli_disablility_benefits, this.answerOptionIdKeyBinding.sbli_disablility_benefits, i.sbli_disablility_benefits), n.appQA.push(me)), i.hasOwnProperty("sbli_parentsibling_disease") && (Ie = this.createJSON(this.questionIdKeyBinding.sbli_parentsibling_disease, this.answerOptionIdKeyBinding.sbli_parentsibling_disease, i.sbli_parentsibling_disease), n.appQA.push(Ie)), i.hasOwnProperty("sbli_disease_sibling_died") && (Oe = this.createJSON(this.questionIdKeyBinding.sbli_disease_sibling_died, this.answerOptionIdKeyBinding.sbli_disease_sibling_died, i.sbli_disease_sibling_died), n.appQA.push(Oe)), i.hasOwnProperty("sbli_disease_two_or_more_sibling_died") && (fe = this.createJSON(this.questionIdKeyBinding.sbli_disease_two_or_more_sibling_died, this.answerOptionIdKeyBinding.sbli_disease_two_or_more_sibling_died, i.sbli_disease_two_or_more_sibling_died), n.appQA.push(fe)), i.hasOwnProperty("sbli_two_year_plan") && (we = this.createJSON(this.questionIdKeyBinding.sbli_two_year_plan, this.answerOptionIdKeyBinding.sbli_two_year_plan, i.sbli_two_year_plan), n.appQA.push(we)), i.hasOwnProperty("sbli_two_year_plan_pilot") && (Se = this.createJSON(this.questionIdKeyBinding.sbli_two_year_plan_pilot, this.answerOptionIdKeyBinding.sbli_two_year_plan_pilot, i.sbli_two_year_plan_pilot), n.appQA.push(Se)), i.hasOwnProperty("sbli_two_year_plan_underwater") && (ve = this.createJSON(this.questionIdKeyBinding.sbli_two_year_plan_underwater, this.answerOptionIdKeyBinding.sbli_two_year_plan_underwater, i.sbli_two_year_plan_underwater), n.appQA.push(ve)), i.hasOwnProperty("sbli_diagnosed_or_tratment_cancer") && (Be = this.createJSON(this.questionIdKeyBinding.sbli_diagnosed_or_tratment_cancer, this.answerOptionIdKeyBinding.sbli_diagnosed_or_tratment_cancer, i.sbli_diagnosed_or_tratment_cancer), n.appQA.push(Be)), i.hasOwnProperty("sbli_carcinoma_skin") && (Te = this.createJSON(this.questionIdKeyBinding.sbli_carcinoma_skin, this.answerOptionIdKeyBinding.sbli_carcinoma_skin, i.sbli_carcinoma_skin), n.appQA.push(Te)), i.hasOwnProperty("sbli_diagnosed_or_tratment_drug_abuse") && (Ae = this.createJSON(this.questionIdKeyBinding.sbli_diagnosed_or_tratment_drug_abuse, this.answerOptionIdKeyBinding.sbli_diagnosed_or_tratment_drug_abuse, i.sbli_diagnosed_or_tratment_drug_abuse), n.appQA.push(Ae)), i.hasOwnProperty("sbli_guilty_felony") && (Ke = this.createJSON(this.questionIdKeyBinding.sbli_guilty_felony, this.answerOptionIdKeyBinding.sbli_guilty_felony, i.sbli_guilty_felony), n.appQA.push(Ke)), i.hasOwnProperty("sbli_diagnosed_or_treatment_Covid") && (Pe = this.createJSON(this.questionIdKeyBinding.sbli_diagnosed_or_treatment_Covid, this.answerOptionIdKeyBinding.sbli_diagnosed_or_treatment_Covid, i.sbli_diagnosed_or_treatment_Covid), n.appQA.push(Pe)), i.hasOwnProperty("sbli_covid_positive_last_30days") && (Ce = this.createJSON(this.questionIdKeyBinding.sbli_covid_positive_last_30days, this.answerOptionIdKeyBinding.sbli_covid_positive_last_30days, i.sbli_covid_positive_last_30days), n.appQA.push(Ce)), i.hasOwnProperty("sbli_Covid_treatment") && (Ne = this.createJSON(this.questionIdKeyBinding.sbli_Covid_treatment, this.answerOptionIdKeyBinding.sbli_Covid_treatment, i.sbli_Covid_treatment), n.appQA.push(Ne)), i.hasOwnProperty("sbli_convicted_reckless_driving") && (xe = this.createJSON(this.questionIdKeyBinding.sbli_convicted_reckless_driving, this.answerOptionIdKeyBinding.sbli_convicted_reckless_driving, i.sbli_convicted_reckless_driving), n.appQA.push(xe)), i.hasOwnProperty("sbli_moving_violations_convicted") && (ke = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted, i.sbli_moving_violations_convicted), n.appQA.push(ke)), i.hasOwnProperty("sbli_hospitalized_other_reason") && (Qe = this.createJSON(this.questionIdKeyBinding.sbli_hospitalized_other_reason, this.answerOptionIdKeyBinding.sbli_hospitalized_other_reason, i.sbli_hospitalized_other_reason), n.appQA.push(Qe)), !i.hasOwnProperty("sbli_moving_violations_convicted_count")) {
                e.next = 103;
                break;
              }
              Je = {}, e.t0 = i.sbli_moving_violations_convicted_count, e.next = 0 === e.t0 ? 85 : 1 === e.t0 ? 88 : 2 === e.t0 ? 91 : 3 === e.t0 ? 94 : 4 === e.t0 ? 97 : 5 === e.t0 ? 100 : 103;
              break;
            case 85:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_one, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_one, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 88:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_two, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_two, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 91:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_three, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_three, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 94:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_four, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_four, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 97:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_five, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_five, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 100:
              return Je = this.createJSON(this.questionIdKeyBinding.sbli_moving_violations_convicted_count_six, this.answerOptionIdKeyBinding.sbli_moving_violations_convicted_count_six, ""), n.appQA.push(Je), e.abrupt("break", 103);
            case 103:
              return i.hasOwnProperty("sbli_depression") && (qe = this.createJSON("1100", "11005", "Yes"), n.appQA.push(qe), qe = this.createJSON(this.questionIdKeyBinding.sbli_depression, this.answerOptionIdKeyBinding.sbli_depression, i.sbli_depression), n.appQA.push(qe)), i.hasOwnProperty("sbli_diabetes_treated") && (Le = this.createJSON("1100", "11004", "Yes"), n.appQA.push(Le), Le = this.createJSON(this.questionIdKeyBinding.sbli_diabetes_treated, this.answerOptionIdKeyBinding.sbli_diabetes_treated, i.sbli_diabetes_treated), n.appQA.push(Le)), i.hasOwnProperty("sbli_oral_medication") && (Ee = this.createJSON(this.questionIdKeyBinding.sbli_oral_medication, this.answerOptionIdKeyBinding.sbli_oral_medication, i.sbli_oral_medication), n.appQA.push(Ee)), i.hasOwnProperty("sbli_Hemoglobin_below7") && (Re = this.createJSON(this.questionIdKeyBinding.sbli_Hemoglobin_below7, this.answerOptionIdKeyBinding.sbli_Hemoglobin_below7, i.sbli_Hemoglobin_below7), n.appQA.push(Re)), i.hasOwnProperty("sbli_Emphysema") && (Fe = this.createJSON(this.questionIdKeyBinding.sbli_Emphysema, this.answerOptionIdKeyBinding.sbli_Emphysema, i.sbli_Emphysema), n.appQA.push(Fe)), i.hasOwnProperty("sbli_Peripheral") && (Me = this.createJSON(this.questionIdKeyBinding.sbli_Peripheral, this.answerOptionIdKeyBinding.sbli_Peripheral, i.sbli_Peripheral), n.appQA.push(Me)), i.hasOwnProperty("sbli_HIV") && (Ye = this.createJSON(this.questionIdKeyBinding.sbli_HIV, this.answerOptionIdKeyBinding.sbli_HIV, i.sbli_HIV), n.appQA.push(Ye)), i.hasOwnProperty("sbli_Kidneydisease") && (He = this.createJSON(this.questionIdKeyBinding.sbli_Kidneydisease, this.answerOptionIdKeyBinding.sbli_Kidneydisease, i.sbli_Kidneydisease), n.appQA.push(He)), i.hasOwnProperty("sbli_Livercirrhosis") && (Ue = this.createJSON(this.questionIdKeyBinding.sbli_Livercirrhosis, this.answerOptionIdKeyBinding.sbli_Livercirrhosis, i.sbli_Livercirrhosis), n.appQA.push(Ue)), i.hasOwnProperty("sbli_ALS") && (Ge = this.createJSON(this.questionIdKeyBinding.sbli_ALS, this.answerOptionIdKeyBinding.sbli_ALS, i.sbli_ALS), n.appQA.push(Ge)), i.hasOwnProperty("sbli_Stroke") && (ze = this.createJSON(this.questionIdKeyBinding.sbli_Stroke, this.answerOptionIdKeyBinding.sbli_Stroke, i.sbli_Stroke), n.appQA.push(ze)), i.hasOwnProperty("sbli_Rheumatoidarthritis") && (De = this.createJSON("1100", "110012", "Yes"), n.appQA.push(De), De = this.createJSON(this.questionIdKeyBinding.sbli_Rheumatoidarthritis, this.answerOptionIdKeyBinding.sbli_Rheumatoidarthritis, i.sbli_Rheumatoidarthritis), n.appQA.push(De)), i.hasOwnProperty("sbli_SleepApnea") && (Ve = this.createJSON("1100", "110013", "Yes"), n.appQA.push(Ve), Ve = this.createJSON(this.questionIdKeyBinding.sbli_SleepApnea, this.answerOptionIdKeyBinding.sbli_SleepApnea, i.sbli_SleepApnea), n.appQA.push(Ve)), i.hasOwnProperty("sbli_Asthma") && (We = this.createJSON("1100", "11002", "Yes"), n.appQA.push(We), We = this.createJSON(this.questionIdKeyBinding.sbli_Asthma, this.answerOptionIdKeyBinding.sbli_Asthma, i.sbli_Asthma), n.appQA.push(We)), i.hasOwnProperty("sbli_Heartdisease") && (je = this.createJSON(this.questionIdKeyBinding.sbli_Heartdisease, this.answerOptionIdKeyBinding.sbli_Heartdisease, i.sbli_Heartdisease), n.appQA.push(je)), i.hasOwnProperty("sbli_Noneoftheabove") && (Ze = this.createJSON(this.questionIdKeyBinding.sbli_Noneoftheabove, this.answerOptionIdKeyBinding.sbli_Noneoftheabove, i.sbli_Noneoftheabove), n.appQA.push(Ze)), i.hasOwnProperty("sbli_active_duty") && ($e = this.createJSON(this.questionIdKeyBinding.sbli_active_duty, this.answerOptionIdKeyBinding.sbli_active_duty, i.sbli_active_duty), n.appQA.push($e)), i.hasOwnProperty("sbli_reserve_national_guard") && "Yes" != i.sbli_active_duty && (Xe = this.createJSON(this.questionIdKeyBinding.sbli_reserve_national_guard, this.answerOptionIdKeyBinding.sbli_reserve_national_guard, i.sbli_reserve_national_guard), n.appQA.push(Xe)), i.hasOwnProperty("sbli_troubled_areas") && (et = this.createJSON(this.questionIdKeyBinding.sbli_troubled_areas, this.answerOptionIdKeyBinding.sbli_troubled_areas, i.sbli_troubled_areas), n.appQA.push(et)), i.hasOwnProperty("sbli_hazardous_activity") && (tt = this.createJSON(this.questionIdKeyBinding.sbli_hazardous_activity, this.answerOptionIdKeyBinding.sbli_hazardous_activity, i.sbli_hazardous_activity), n.appQA.push(tt)), i.hasOwnProperty("sbli_neither_of_these") && (it = this.createJSON(this.questionIdKeyBinding.sbli_neither_of_these, this.answerOptionIdKeyBinding.sbli_neither_of_these, i.sbli_neither_of_these), n.appQA.push(it)), console.log("answerJSON : ", n), e.next = 127, utilityModule.getClientIdTimestamp(this.clientId);
            case 127:
              return st = e.sent, e.next = 130, backendService.getQuotesFromSBLIAfficiency(n, st, this.dataCategory.submitAPPQA, this.clientId, "SBLI");
            case 130:
              return nt = e.sent, e.abrupt("return", this.getProcessedOutput(nt));
            case 132:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t, i) {
        return p.apply(this, arguments);
      })
    }, {
      key: "submitAPPQA",
      value: (l = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s,
          n,
          o,
          r,
          a,
          _,
          u,
          l,
          p,
          d = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return s = d.length > 2 && void 0 !== d[2] ? d[2] : {}, this.state = s.state, n = i.answerJSON, o = {
                questionId: "1002",
                answerValue: i.bubble_heightFt + "." + i.bubble_heightIn
              }, n.push(o), r = {
                questionId: "1003",
                answerValue: i.bubble_weight
              }, n.push(r), a = "10805", a = i.SBLI.tobacco_usage_one && "Yes" == i.SBLI.tobacco_usage_one ? "10801" : i.SBLI.tobacco_usage_two && "Yes" == i.SBLI.tobacco_usage_two ? "10802" : i.SBLI.tobacco_usage_three && "Yes" == i.SBLI.tobacco_usage_three ? "10803" : i.SBLI.tobacco_usage_four && "Yes" == i.SBLI.tobacco_usage_four ? "10804" : "10805", _ = {
                questionId: "1080",
                answerOptionId: a,
                answerValue: "1"
              }, n.push(_), u = {
                appQA: n,
                arcId: t
              }, console.log("DQ answer JSON : ", u), e.next = 15, utilityModule.getClientIdTimestamp(this.clientId);
            case 15:
              return l = e.sent, e.next = 18, backendService.getQuotesFromSBLIAfficiency(u, l, this.dataCategory.submitAPPQA, this.clientId, "SBLI");
            case 18:
              return p = e.sent, e.abrupt("return", this.getProcessedOutput(p));
            case 20:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return l.apply(this, arguments);
      })
    }, {
      key: "submitAUTH",
      value: (u = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var i, s, n, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.getFormattedDate();
            case 2:
              return i = e.sent, s = {
                arcId: t,
                hippaConsentFlag: 1,
                hippaConsentTimestamp: i,
                aggrementDisclosureConsent: 1
              }, console.log("submitAUTH sbliInputJson : ", s), e.next = 7, utilityModule.getClientIdTimestamp(this.clientId);
            case 7:
              return n = e.sent, e.next = 10, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.submitAUTH, this.clientId, "SBLI");
            case 10:
              return o = e.sent, e.abrupt("return", this.getProcessedOutput(o));
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return u.apply(this, arguments);
      })
    }, {
      key: "getDECISION",
      value: (_ = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var i, s, n, o, r, a;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return this.arcId = t, i = {
                arcId: t,
                callReferenceCode: 1
              }, e.next = 4, utilityModule.getClientIdTimestamp(this.clientId);
            case 4:
              return s = e.sent, e.next = 7, backendService.getQuotesFromSBLIAfficiency(i, s, this.dataCategory.getDECISION, this.clientId, "SBLI");
            case 7:
              if (n = e.sent, !((o = (o = JSON.parse(n.Payload)).body.output).length > 0)) {
                e.next = 20;
                break;
              }
              if (200 == o[0]["output.statusCode"]) {
                e.next = 16;
                break;
              }
              return r = {
                sbliError: !0,
                sbliOutput: o[0],
                statusCode: o[0]["output.statusCode"],
                msgCode: o[0]["output.msgCode"],
                msgText: o[0]["output.msgText"] ? o[0]["output.msgText"] : o[0]["output.msgTxt"]
              }, e.abrupt("return", r);
            case 16:
              return a = {
                sbliError: !1,
                sbliOutput: o[0],
                maxAllowedCoverage: o[0]["output.maxAllowedCoverageByTerm"],
                statusCode: o[0]["output.statusCode"],
                msgCode: o[0]["output.msgCode"],
                msgText: o[0]["output.msgText"] ? o[0]["output.msgText"] : o[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 18:
              e.next = 21;
              break;
            case 20:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 21:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return _.apply(this, arguments);
      })
    }, {
      key: "getFORMS",
      value: (a = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return s = {
                arcId: t,
                callReferenceCode: i
              }, e.next = 3, utilityModule.getClientIdTimestamp(this.clientId);
            case 3:
              return n = e.sent, e.next = 6, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.getFORMS, this.clientId, "SBLI");
            case 6:
              if (o = e.sent, !((r = (r = JSON.parse(o.Payload)).body.output).length > 0)) {
                e.next = 19;
                break;
              }
              if (200 == r[0]["output.statusCode"]) {
                e.next = 15;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: r[0],
                formsJson: r[0]["output.formsJson"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 15:
              return _ = {
                sbliError: !1,
                sbliOutput: r[0],
                formsJson: r[0]["output.formsJson"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", _);
            case 17:
              e.next = 20;
              break;
            case 19:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 20:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "submitBENE",
      value: (r = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _, u, l, p, d;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.getFormattedDate();
            case 2:
              if (s = e.sent, n = {
                arcId: t,
                beneficiaryInfo: [],
                beneficiaryConsentFlag: 0,
                beneficiaryConsentTimeStamp: s,
                designeeFlag: 0,
                designee: {}
              }, (o = i.sbli_beneficiaryInfo).length > 0) for (n.beneficiaryConsentFlag = 1, r = 0; r < o.length; r++) a = void 0, a = "Parent" == o[r].sbli_addBeneficiaryRelationship || "Sibling" == o[r].sbli_addBeneficiaryRelationship || "Domestic Partner" == o[r].sbli_addBeneficiaryRelationship ? "OtherNamedIndividual" : o[r].sbli_addBeneficiaryRelationship, _ = {
                firstName: o[r].sbli_addBeneficiaryFirstName,
                lastName: o[r].sbli_addBeneficiaryLastName,
                relationship: o[r].sbli_addBeneficiaryRelationship,
                relationshipType: a,
                dob: o[r].sbli_addBeneficiaryDob,
                percentage: o[r].sbli_addBeneficiaryPercentage
              }, n.beneficiaryInfo.push(_);else n.beneficiaryConsentFlag = 0;
              return "Yes" == i.sbli_contact_for_premium_amount ? (n.designeeFlag = 1, u = i.sbli_contact_details, l = (l = (l = u.sbli_addBeneficiary_DaytimePhone).toString()).replace(/ /g, ""), n.designee.firstName = u.sbli_addBeneficiary_FirstName, n.designee.lastName = u.sbli_addBeneficiary_LastName, n.designee.address1 = u.sbli_addBeneficiary_HomeAddress, n.designee.state = u.sbli_addBeneficiary_State, n.designee.city = u.sbli_addBeneficiary_City, n.designee.zip = u.sbli_addBeneficiary_Zipcode, n.designee.phone = l, n.designee.relationshipType = "designee", n.designee.email = u.sbli_addBeneficiary_EmailId) : n.designeeFlag = 0, console.log("submitBENE sbliInputJson : ", n), e.next = 10, utilityModule.getClientIdTimestamp(this.clientId);
            case 10:
              return p = e.sent, e.next = 13, backendService.getQuotesFromSBLIAfficiency(n, p, this.dataCategory.submitBENE, this.clientId, "SBLI");
            case 13:
              return d = e.sent, e.abrupt("return", this.getProcessedOutput(d));
            case 15:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getPREMIUM",
      value: (o = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _, u;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return i.term = +i.term >= 20 ? "20" : i.term, i.term = +i.term >= 15 && i.term < 20 ? "15" : i.term, i.term = +i.term >= 10 && i.term < 15 ? "10" : i.term, s = {
                arcId: t,
                coverage: i.coverage,
                term: i.term
              }, console.log("getPREMIUM sbliInputJson : ", s), e.next = 7, utilityModule.getClientIdTimestamp(this.clientId);
            case 7:
              return n = e.sent, e.next = 10, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.getPREMIUM, this.clientId, "SBLI");
            case 10:
              if (o = e.sent, !((r = (r = JSON.parse(o.Payload)).body.output).length > 0)) {
                e.next = 26;
                break;
              }
              if (200 == r[0]["output.statusCode"]) {
                e.next = 19;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: r[0],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 19:
              return _ = {
                id: this.clientId,
                clientId: this.clientId,
                uid: this.clientId,
                sbli_premiumMonthly: r[0]["output.premiumMonthly"],
                sbli_premiumAnnually: r[0]["output.premiumAnnually"],
                sbli_premiumQuaterly: r[0]["output.premiumQuaterly"],
                sbli_premiumSemiAnnually: r[0]["output.premiumSemiAnnually"]
              }, e.next = 22, backendService.saveUpdateClientData(this.clientId, _);
            case 22:
              return u = {
                sbliError: !1,
                sbliOutput: r[0],
                premiumMonthly: r[0]["output.premiumMonthly"],
                premiumAnnually: r[0]["output.premiumAnnually"],
                premiumQuaterly: r[0]["output.premiumQuaterly"],
                premiumSemiAnnually: r[0]["output.premiumSemiAnnually"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", u);
            case 24:
              e.next = 27;
              break;
            case 26:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 27:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return o.apply(this, arguments);
      })
    }, {
      key: "offerACCEPTANCE",
      value: (n = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return i.term = +i.term >= 20 ? "20" : i.term, i.term = +i.term >= 15 && i.term < 20 ? "15" : i.term, i.term = +i.term >= 10 && i.term < 15 ? "10" : i.term, s = {
                arcId: t,
                coverage: i.coverage,
                term: i.term,
                premium: i.premium
              }, console.log("offerACCEPTANCE sbliInputJson : ", s), e.next = 7, utilityModule.getClientIdTimestamp(this.clientId);
            case 7:
              return n = e.sent, e.next = 10, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.offerACCEPTANCE, this.clientId, "SBLI");
            case 10:
              if (o = e.sent, !((r = (r = JSON.parse(o.Payload)).body.output).length > 0)) {
                e.next = 23;
                break;
              }
              if (200 == r[0]["output.statusCode"]) {
                e.next = 19;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: r[0],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 19:
              return _ = {
                sbliError: !1,
                sbliOutput: r[0],
                maxAllowedCoverage: r[0]["output.maxAllowedCoverage"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", _);
            case 21:
              e.next = 24;
              break;
            case 23:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 24:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "appSIGN",
      value: (s = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return s = {
                arcId: i,
                appSignConsentJson: [{
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 904,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 905,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 906,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 907,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 910,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 911,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 912,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 913,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }, {
                  esign_timestamp: "2020-06-02 15:10:12",
                  form_no: 920,
                  doc_full_view_flag: 1,
                  esign_flag: 1
                }],
                callReferenceCode: 207
              }, "CA" === t && s.appSignConsentJson.push({
                esign_timestamp: "2020-06-02 15:10:12",
                form_no: 919,
                doc_full_view_flag: 1,
                esign_flag: 1
              }), e.next = 4, utilityModule.getClientIdTimestamp(this.clientId);
            case 4:
              return n = e.sent, e.next = 7, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.appSIGN, this.clientId, "SBLI");
            case 7:
              return o = e.sent, e.abrupt("return", this.getProcessedOutput(o));
            case 9:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return s.apply(this, arguments);
      })
    }, {
      key: "submitPAYINFO",
      value: (i = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i, s) {
        var n, o, r, a, _, u;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.getFormattedDate();
            case 2:
              return n = e.sent, o = "", o = "1" == (r = s).sbli_paymentFrequency ? t.sbli_premiumMonthly : t.sbli_premiumAnnually, a = {
                arcId: t.arcId,
                payType: 2,
                payMethod: 2,
                bankAccountNo: r.sbli_bankAccountNumber,
                bankAccountType: r.sbli_bankAccountType,
                bankRoutingNo: r.sbli_bankRoutingNo,
                bankName: r.sbli_bankName,
                paymentType: "",
                payStatus: 1,
                paymentFrequency: r.sbli_paymentFrequency,
                paymentPremium: o,
                tokenId: "",
                payConsent: 1,
                payConsentTimeStamp: n
              }, console.log("submitPAYINFO sbliInputJson : ", a), e.next = 10, utilityModule.getClientIdTimestamp(this.clientId);
            case 10:
              return _ = e.sent, e.next = 13, backendService.getQuotesFromSBLIAfficiency(a, _, this.dataCategory.submitPAYINFO, this.clientId, "SBLI");
            case 13:
              return u = e.sent, e.abrupt("return", this.getProcessedOutput(u));
            case 15:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t, s) {
        return i.apply(this, arguments);
      })
    }, {
      key: "getPOLICYNUMBER",
      value: (t = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var i, s, n, o, r, a;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return i = {
                arcId: t
              }, e.next = 3, utilityModule.getClientIdTimestamp(this.clientId);
            case 3:
              return s = e.sent, e.next = 6, backendService.getQuotesFromSBLIAfficiency(i, s, this.dataCategory.getPOLICYNUMBER, this.clientId, "SBLI");
            case 6:
              if (n = e.sent, !((o = (o = JSON.parse(n.Payload)).body.output).length > 0)) {
                e.next = 19;
                break;
              }
              if (200 == o[0]["output.statusCode"]) {
                e.next = 15;
                break;
              }
              return r = {
                sbliError: !0,
                sbliOutput: o[0],
                statusCode: o[0]["output.statusCode"],
                msgCode: o[0]["output.msgCode"],
                msgText: o[0]["output.msgText"] ? o[0]["output.msgText"] : o[0]["output.msgTxt"]
              }, e.abrupt("return", r);
            case 15:
              return a = {
                sbliError: !1,
                sbliOutput: o[0],
                policyNumber: o[0]["output.policyNumber"],
                statusCode: o[0]["output.statusCode"],
                msgCode: o[0]["output.msgCode"],
                msgText: o[0]["output.msgText"] ? o[0]["output.msgText"] : o[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 17:
              e.next = 20;
              break;
            case 19:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 20:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "updateSESSION",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, i) {
        var s, n, o, r, a, _;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return s = {
                arcId: t,
                sessionStatus: i
              }, e.next = 3, utilityModule.getClientIdTimestamp(this.clientId);
            case 3:
              return n = e.sent, e.next = 6, backendService.getQuotesFromSBLIAfficiency(s, n, this.dataCategory.updateSESSION, this.clientId, "SBLI");
            case 6:
              if (o = e.sent, !((r = (r = JSON.parse(o.Payload)).body.output).length > 0)) {
                e.next = 19;
                break;
              }
              if (200 == r[0]["output.statusCode"]) {
                e.next = 15;
                break;
              }
              return a = {
                sbliError: !0,
                sbliOutput: r[0],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", a);
            case 15:
              return _ = {
                sbliError: !1,
                sbliOutput: r[0],
                policyNumber: r[0]["output.policyNumber"],
                statusCode: r[0]["output.statusCode"],
                msgCode: r[0]["output.msgCode"],
                msgText: r[0]["output.msgText"] ? r[0]["output.msgText"] : r[0]["output.msgTxt"]
              }, e.abrupt("return", _);
            case 17:
              e.next = 20;
              break;
            case 19:
              return e.abrupt("return", {
                sbliError: !0
              });
            case 20:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (t, i) {
        return e.apply(this, arguments);
      })
    }, {
      key: "getProcessedOutput",
      value: function (e) {
        var t = JSON.parse(e.Payload);
        return (t = t.body.output).length > 0 ? 200 != t[0]["output.statusCode"] ? {
          sbliError: !0,
          sbliOutput: t[0],
          statusCode: t[0]["output.statusCode"],
          msgCode: t[0]["output.msgCode"],
          msgText: t[0]["output.msgText"] ? t[0]["output.msgText"] : t[0]["output.msgTxt"]
        } : {
          sbliError: !1,
          sbliOutput: t[0],
          statusCode: t[0]["output.statusCode"],
          msgCode: t[0]["output.msgCode"],
          msgText: t[0]["output.msgText"] ? t[0]["output.msgText"] : t[0]["output.msgTxt"]
        } : {
          sbliError: !0
        };
      }
    }, {
      key: "createJSON",
      value: function (e, t, i) {
        var s = {};
        return s.questionId = e, null != t && null != t && "" != t && (s.answerOptionId = t), s.answerValue = "Yes" == i ? "1" : "No" == i ? "0" : "" == i ? "1" : i, s;
      }
    }, {
      key: "getAge",
      value: function (e) {
        var t = new Date(),
          i = new Date(e);
        i.getMonth(), i.getDate(), i.getFullYear();
        return t.getFullYear() - i.getFullYear();
      }
    }, {
      key: "getSBLIAmount",
      value: function (e) {
        var t = "0",
          i = !1;
        return (e = JSON.parse(e.Payload)).body && e.body.output && (t = e.body.output[0]["output.monthlyQuote"], console.log("sbliOutput.body.output:", e.body.output)), "0" == (t = t || "0") && (i = !0), {
          sbliAmount: t = "$".concat(t),
          sbliannualamount: "".concat(e.body.output[0]["output.annualQuote"]),
          sbliError: i
        };
      }
    }, {
      key: "getFormattedDate",
      value: function () {
        var e = new Date();
        return e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate() + e.getHours() + ":" + e.getMinutes() + ":" + e.getSeconds();
      }
    }]);
    var e, t, i, s, n, o, r, a, _, u, l, p, d, b, c, h, g;
  }();
module.exports = {
  SbliHelper: SbliHelper
};